/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionalLinkSpeciality } from '../../models/promotional-link-speciality';

export interface AnonymousSpecialityPromotionalLinkIdGet$Params {
  id: string;
}

export function anonymousSpecialityPromotionalLinkIdGet(http: HttpClient, rootUrl: string, params: AnonymousSpecialityPromotionalLinkIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<PromotionalLinkSpeciality>> {
  const rb = new RequestBuilder(rootUrl, anonymousSpecialityPromotionalLinkIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<PromotionalLinkSpeciality>;
    })
  );
}

anonymousSpecialityPromotionalLinkIdGet.PATH = '/Anonymous/SpecialityPromotionalLink/{id}';
